import { getThemeMode } from './colors';

// Conversation palette: soft gold outgoing bubbles with dark text (light) / deep gold with
// light text (dark), plain incoming bubbles, and a quiet wallpaper behind them.
const light = {
  wallpaper: '#F3EDE3',
  out: {
    bg: '#F8E4BC',
    text: '#0A0F1E',
    subtle: 'rgba(10, 15, 30, 0.55)',
    accent: '#8A5A0E',
    chip: 'rgba(138, 90, 14, 0.12)',
    line: 'rgba(138, 90, 14, 0.35)',
  },
  in: {
    bg: '#FFFFFF',
    text: '#0A0F1E',
    subtle: 'rgba(10, 15, 30, 0.5)',
    border: 'rgba(10, 15, 30, 0.06)',
    chip: 'rgba(10, 15, 30, 0.05)',
  },
  read: '#2F80C8',
  sheet: '#FFFFFF',
  sheetScrim: 'rgba(10, 15, 30, 0.35)',
};

const dark = {
  wallpaper: '#0B1122',
  out: {
    bg: '#4D3A14',
    text: '#FFF6E5',
    subtle: 'rgba(255, 246, 229, 0.62)',
    accent: '#F0B558',
    chip: 'rgba(240, 181, 88, 0.16)',
    line: 'rgba(240, 181, 88, 0.4)',
  },
  in: {
    bg: '#18203A',
    text: '#FFFFFF',
    subtle: 'rgba(255, 255, 255, 0.5)',
    border: 'rgba(255, 255, 255, 0.06)',
    chip: 'rgba(255, 255, 255, 0.07)',
  },
  read: '#5BB0F0',
  sheet: '#121A30',
  sheetScrim: 'rgba(0, 0, 0, 0.55)',
};

const current = () => (getThemeMode() === 'light' ? light : dark);

/** Getters, so values follow the active palette like `colors` does. */
export const chat = {
  get wallpaper() { return current().wallpaper; },
  get out() { return current().out; },
  get in() { return current().in; },
  get read() { return current().read; },
  get sheet() { return current().sheet; },
  get sheetScrim() { return current().sheetScrim; },
};
